export class CardMiniEntity {
  id?: number
  name?: string | null
  order?: number
  startDate?: string
  expireDate?: string | null
  regionsCount?: number
  channelName?: string
  imagePath?: string | null
}
